module.exports = __webpack_public_path__ + "static/media/SK1.3095c6e2.jpg";